import React, { Component } from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import { withStateHandlers } from 'recompose';

import {
  Button,
  ButtonToolbar,
  Row,
  Col,
  Modal,
  FormGroup,
  ControlLabel,
} from 'react-bootstrap';

import { Field, reduxForm, formPropTypes, SubmissionError } from 'redux-form';
import TaxScheduleInput from '../../fields/TaxScheduleInput/index';
import CustomerInput from '../../fields/CustomerInput/index';

import { tryHandleGraphQLError } from '../../../utils/graphQLErrorHandlers';
import { openInNewTab } from '../../../utils';
import { getTicketLink } from '../../ticketViewer/links';
import TicketSubmissionItemViewer from '../../tickets/components/TicketSubmissionItemViewer';

const FORM_NAME = 'sageInfoForm';

export const sageInfoModalPropTypes = {
  openSageInfoModal: PropTypes.func.isRequired,
  closeSageInfoModal: PropTypes.func.isRequired,
  showSageInfoModal: PropTypes.bool.isRequired,
  clickedDeferJobInfoModal: PropTypes.bool,
};


export const withSageInfoModalState = withStateHandlers(
  (props) => {
    return {
      showSageInfoModal: false,
      clickedDeferJobInfoModal: false,
    };
  },
  {
    openSageInfoModal: (state, props) => {
      return (clickedDefer) => {
        return { showSageInfoModal: true, clickedDeferJobInfoModal: clickedDefer };
      };
    },
    closeSageInfoModal: (state, props) => {
      return () => { return { showSageInfoModal: false }; };
    },
  },
);


const propTypes = exact({
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  lease: PropTypes.object.isRequired,
  job: PropTypes.object.isRequired,
  createJobInvoiceAction: PropTypes.func.isRequired,
  validate: PropTypes.func.isRequired,

  ticketId: PropTypes.number.isRequired,
  deferJob: PropTypes.func,
  clickedDeferJob: PropTypes.bool,
  ...formPropTypes,

});

const validate = (values) => {
  const errors = {};

  if (!values.customer) {
    errors.customer = 'Required';
  }

  if (!values.tax_schedule) {
    errors.tax_schedule = 'Required';
  }
  return errors;
};

/* eslint-disable */
const createRenderer = (render) => ({ input, meta, label, ...rest }) => {
  return (
    <div
      className={[
        meta.error && meta.touched ? 'form-error' : '',
        meta.active ? 'form-active' : '',
      ].join(' ')}
    >
      <ControlLabel>
        {label}
      </ControlLabel>

      {render(input, label, rest)}

      {meta.error && meta.touched &&
      <span>
          {meta.error}
        </span>
      }
    </div>
  );
};
/* eslint-enable */

const RenderTaxSchedule = createRenderer((input, label, { disabled }) => {
  return (
    <TaxScheduleInput disabled={disabled} {...input} />
  );
});

const RenderCustomer = createRenderer((input, label, { disabled }) => {
  return (
    <CustomerInput disabled={disabled} {...input} />
  );
});


export class SageInfoModal extends Component {
  constructor(props) {
    super(props);

    this.handleCompleteSageInfo = this.handleCompleteSageInfo.bind(this);
    this.resetAndClose = this.resetAndClose.bind(this);
  }

  resetAndClose() {
    const { reset, onHide } = this.props;
    reset();
    onHide();
  }

  async handleCompleteSageInfo(values) {
    const { onSubmit, lease } = this.props;
    const { createJobInvoiceAction, job, clickedDeferJob, deferJob, ticketId } = this.props;
    try {
      const leaseObj = {
        id: lease.id,
        name: lease.name,
      };
      const { customer, tax_schedule: taxSchedule } = values;

      await onSubmit(leaseObj, customer.id, taxSchedule.id, job);

      if (clickedDeferJob) {
        await deferJob(job.id);
      } else {
        await createJobInvoiceAction(job.id);
      }
      openInNewTab(getTicketLink(ticketId, job.id));
      this.resetAndClose();
    } catch (e) {
      const message = tryHandleGraphQLError(e);
      const errorMessage = (message.length) ? message : 'There is an issue with the sage server. Contact support and try again later.';
      throw new SubmissionError({ _error: errorMessage });
    }
  }

  render() {
    const { show } = this.props;

    const {
      handleSubmit,
      invalid,
      submitting,
      pristine,
      error,
      ticketId,
    } = this.props;

    return (
      <Modal show={show} onHide={this.resetAndClose}>
        <Modal.Header closeButton>
          <Modal.Title>Lease Information</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <TicketSubmissionItemViewer ticketId={ticketId} />
          <form onSubmit={handleSubmit(this.handleCompleteSageInfo)}>
            <FormGroup>
              <Row>
                <Col xs={6}>
                  <FormGroup>
                    <Field name="customer" type="text" label="Acct. Customer" format={null} component={RenderCustomer} />
                  </FormGroup>
                </Col>
                <Col xs={6}>
                  <FormGroup>
                    <Field name="tax_schedule" type="text" label="Acct. Tax Schedule" format={null} component={RenderTaxSchedule} />
                  </FormGroup>
                </Col>
              </Row>
            </FormGroup>
            <Row>
              <Col md={12}>
                <ButtonToolbar className="pull-right">
                  <Button
                    bsStyle="warning"
                    onClick={this.resetAndClose}
                  >
                    Cancel
                  </Button>
                  <Button
                    type="submit"
                    bsStyle="primary"
                    disabled={submitting || pristine || invalid}
                  >
                    Update & Send to Sage
                  </Button>
                </ButtonToolbar>
              </Col>
            </Row>
            <label>{error && <strong>{error}</strong>}</label>
          </form>
        </Modal.Body>
      </Modal>
    );
  }
}

SageInfoModal.propTypes = propTypes;

SageInfoModal.defaultProps = {
  clickedDeferJob: false,
};

export default reduxForm({
  form: FORM_NAME,
  enableReinitialize: true,
  validate,
})(SageInfoModal);
